export var COMMON_INTERNAL_ERROR_MSG = '服务异常，请稍后重试';